import { createAction, props } from '@ngrx/store';
import {
  SiteType,
  Site,
  Area,
  AreaRoomData,
  UserRole,
  DynamicContent
} from '@shared/models/';


export const retrievedSiteTypesList = createAction(
  '[Site Types List/API] Retrieve Site Types Success',
  props<{ siteTypes: ReadonlyArray<SiteType> }>()
);

export const retrievedSitesList = createAction(
  '[Sites List/API] Retrieve Sites Success',
  props<{ sites: ReadonlyArray<Site> }>()
);

export const retrievedAreaList = createAction(
  '[Area List/API] Retrieve Areas Success',
  props<{ areas: ReadonlyArray<Area> }>()
);

export const retrievedRoomsList = createAction(
  '[Room List/API] Retrieve Rooms Success',
  props<{ rooms: ReadonlyArray<AreaRoomData> }>()
);

export const retrievedDynamicContentList = createAction(
  '[Dynamic Content List / API] Retrieve dynamic content success',
  props<{ dynamicContent: ReadonlyArray<DynamicContent> }>(),
);

export const userRolesList = createAction(
  '[User Roles List/API Retrieve User Roles Success',
  props<{ user_roles: ReadonlyArray<UserRole> }>()
)
